import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VendorBankRequest } from 'src/app/models/vendor.model';
import { VendorBankService } from 'src/app/services/vendor-bank.service';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthenticationService } from '../../pages/authentication/authentication/authentication.service';

@Component({
  selector: 'app-modal-vendor-bank',
  templateUrl: './modal-vendor-bank.component.html',
  styleUrls: ['./modal-vendor-bank.component.scss']
})
export class ModalVendorBankComponent implements OnInit {
  @Input() isCreating = true;
  @Input() vendorBank: VendorBankRequest = new VendorBankRequest();
  @Input() idVendor: number;
  @Output() close = new EventEmitter<boolean>();

  currentStep = 1;
  loading = false;
  banks: any[] = [];
  currentCompany = null;
  vendorBanks: any[] = [];

  constructor(
    private vendorBankService: VendorBankService,
    private toastService: ToastrService,
    private authService: AuthenticationService,
  ) {
    this.currentCompany = JSON.parse(authService.getCurrentCompany());
  }

  ngOnInit(): void {
    if (!this.vendorBank) this.vendorBank = new VendorBankRequest();
    if (this.isCreating) this.vendorBank.id = null;
    this.vendorBank.idVendor = this.idVendor;
    this.getAllBanks();
    this.getVendorBanksByIdVendor();
  }

  displayStep(step: number) {
    this.currentStep = step;
  }

  save() {
    this.loading = true;

    const observable = this.isCreating
      ? this.vendorBankService.createVendorBank(this.vendorBank, this.currentCompany)
      : this.vendorBankService.updateVendorBank(this.vendorBank, this.currentCompany);


    observable.subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success('Cuenta bancaria guardada correctamente');
        this.close.emit(true);
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error || 'Error al guardar');
        this.loading = false;
      }
    });
  }

  
  getAllBanks() {
    this.vendorBankService.getBanks().subscribe({
      next: (response: ResponseObject) => {
        this.banks = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  getVendorBanksByIdVendor() {
    this.vendorBankService.getVendorBanksByVendorId(this.idVendor).subscribe({
      next: (response: ResponseObject) => {
        this.vendorBanks = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  onSelectVendorBank(event: any) {
    const selectedId = Number(event.target.value);

    if (selectedId === -1) {
      this.isCreating = true;
      this.vendorBank = new VendorBankRequest();
      this.vendorBank.idVendor = this.idVendor;
    } else {
      const selected = this.vendorBanks.find(vb => vb.id === selectedId);
      if (selected) {
        this.isCreating = false;
        this.vendorBank = { ...selected };
      }
    }
  }

  getBankNameById(id: number): string {
    const bank = this.banks.find(b => b.id === id);
    return bank ? bank.name : 'Banco desconocido';
  }




}
